import React, { ReactNode, useEffect } from 'react';
import { PageGrid, PageContainer } from './page-layout';
import { B2B_ANALYTICS, B2B_BREADCRUMBS, ERR_GENERIC } from '../../constants';
import { RewardsAndOffersContext } from '../../contexts';
import { windowExists } from '../Utils';
import { setAnalytics } from '../../utils/analytics';
import Spinner from './spinner/spinner';

interface PricingPageLayoutProps {
  children: ReactNode;
  title?: string;
}

/**
 * Shared layout component for pricing-related pages
 * Removes duplication between PricingBookPage and PricingBenefitsPage
 */
export const PricingPageLayout: React.FC<PricingPageLayoutProps> = ({
  children,
  title = 'Pricing Benefits',
}) => {
  const breadcrumbs = B2B_BREADCRUMBS.pricingBenefits;

  const {
    getRewardsAndOffersData,
    isLoading,
    setIsLoading,
    generalError,
    setGeneralError,
  }: any = React.useContext(RewardsAndOffersContext);

  useEffect(() => {
    const apiController = new AbortController();
    getRewardsAndOffersData({ signal: apiController.signal })
      .catch(() => {
        setGeneralError(ERR_GENERIC);
      })
      .finally(() => {
        setIsLoading(false);
      });
    if (windowExists() && window?.digitalData) {
      window.digitalData.page = B2B_ANALYTICS.pricingBenefits;
      setAnalytics(window.digitalData);
    }
    return () => {
      apiController.abort();
    };
  }, []);

  return (
    <PageGrid>
      <PageContainer
        title={title}
        breadcrumbs={breadcrumbs}
        generalError={generalError}
        classes={{
          contentContainer: 'programDetails_page',
        }}
      >
        <Spinner active={isLoading} />
        {children}
      </PageContainer>
    </PageGrid>
  );
};
